import { Bot as BotIcon } from 'lucide-react';

interface Props {
  isRelevantForAiOperator?: boolean;
}

export function AIOperatorLabels(props: Props) {
  const { isRelevantForAiOperator } = props;

  if (isRelevantForAiOperator === undefined) return null;

  return (
    <div className="border-onlight-line-3 dark:border-ondark-line-3 inline-flex items-center gap-1 rounded-full border px-2 py-1">
      <BotIcon className="dark:text-ondark-text-2 text-onlight-text-2 h-4 w-4" />
      <span className="dark:text-ondark-text-2 text-onlight-text-2 text-xs">
        AI Operator: {isRelevantForAiOperator ? 'Enabled' : 'Disabled'}
      </span>
    </div>
  );
}

export default AIOperatorLabels;
